import { instance } from "@/services/axiosConfig";
import { url } from "@/stores/urls";
import { AxiosResponse } from "axios";

class RequestsService {
  getWithParams<T>(endpoint: string, params: any) {
    console.log("params", params);
    return instance.get<T>(`${url.baseURL}${endpoint}/`, { params });
  }
  getWithParamsPDF<T>(endpoint: string, params: any) {
    console.log("params", params);
    return instance.get<T>(`${url.baseURL}${endpoint}/`, {
      params: params,
      responseType: "arraybuffer",
    });
  }
  get<T>(endpoint: string): Promise<AxiosResponse<T>> {
    return instance.get<T>(`${url.baseURL}${endpoint}/`);
  }
  getBlob(endpoint: string): Promise<AxiosResponse<Blob>> {
    return instance.get<Blob>(`${url.baseURL}${endpoint}/`, {
      responseType: "blob",
    });
  }
  getBlobWithParams(endpoint: string, params: any): Promise<AxiosResponse<Blob>> {
    return instance.get<Blob>(`${url.baseURL}${endpoint}/`, {
      params,
      responseType: "blob",
    });
  }
  get2<T>(url: string): Promise<AxiosResponse<T>> {
    return instance.get<T>(`${url}`);
  }
  getDomain<T>(endpoint: string): Promise<AxiosResponse<T>> {
    return instance.get<T>(`${url.domainURL}${endpoint}/`);
  }
  post<T>(endpoint: string, data: any): Promise<AxiosResponse<T>> {
    return instance.post<T>(`${url.baseURL}${endpoint}/`, data);
  }
  post2<T>(endpoint: string, data: any): Promise<AxiosResponse<T>> {
    return instance.post<T>(`${url.baseURL}${endpoint}/`, data, {
      headers: { "Content-Type": "application/json; charset=utf-8" },
    });
  }
  postBlob(endpoint: string, data: any): Promise<AxiosResponse<Blob>> {
    return instance.post<Blob>(`${url.baseURL}${endpoint}/`, data, {
      responseType: "blob",
    });
  }
  put<T>(endpoint: string, data: any): Promise<AxiosResponse<T>> {
    return instance.put<T>(`${url.baseURL}${endpoint}/`, data);
  }
  getFile(filepath: string, filename: string) {
    return instance.get(`${url.mediaURL}${filepath}/${filename}`);
  }
  getServerMediaFile<T>(filepath: string, filename: string, filetype: string) {
    const params = {
      filepath: filepath,
      filename: filename,
      filetype: filetype,
    };
    return instance.get<T>(`${url.baseURL}get-media-file/`, {
      params,
      responseType: "arraybuffer",
    });
  }
  delete<T>(endpoint: string, uuid: string): Promise<AxiosResponse<T>> {
    return instance.delete<T>(`${url.baseURL}${endpoint}/?uuid=${uuid}`);
  }
  delete_v2<T>(endpoint: string, uuid: string): Promise<AxiosResponse<T>> {
    return instance.delete<T>(`${url.baseURL}${endpoint}/${uuid}`);
  }
  delete_v3<T>(endpoint: string, uuid: string): Promise<AxiosResponse<T>> {
    return instance.delete<T>(`${url.baseURL}${endpoint}/${uuid}/`);
  }
  deleteWithData<T>(endpoint: string, data: any): Promise<AxiosResponse<T>> {
    return instance.delete<T>(`${url.baseURL}${endpoint}/`, { data });
  }
  getStatic<T>(endpoint: string) {
    return instance.get<T>(`${url.staticURL}${endpoint}`);
  }
}
const requestService = new RequestsService();
export default requestService;
